import React from 'react';
import { connect } from 'react-redux';
import { Translate } from 'react-localize-redux';
import { withLocalize } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { Circles } from '../../common/loadingComponent';
import { reportActions } from '../../../store/reportStore';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import Paging from '../../common/pagingComponent';
import RelationLink from '../relations/relationLink';
import OldStyleTableWithHistory from '../../common/oldStyleTableWithHistory';
import ResponsiveTable from "../../layoutItems/responsiveTable";

import './publicContractsSection.scss';

class PublicContractsSection extends React.Component {
    state = { page: 1 };

    get section() {
        return this.props.sections.find(o => o.id === this.props.sectionId).subsections.find(q => q.id === this.props.subsectionId);
    }

    get pageSize() {
        const limits = this.props.getSectionLimits(this.props.reportType, this.props.subsectionId);
        return this.section.isLimited ? limits.pageSize.limited : limits.pageSize.unlimited;
    }

    componentDidMount = () => {
        this.props.loadIfExpanded(this.props.sectionId);
    }

    render() {
        const { data, loadingMoreData, isLimited } = this.section;
        const summary = this.props.getParentSection([this.props.sectionId, this.props.subsectionId]).data;
        const subsectionSummary = summary.find(item => item.id === this.props.subsectionData.contractId);
        const isMirriReport = this.section.link.startsWith("mirri");
        return isNullOrUndefined(data) || isNullOrUndefined(summary) || isNullOrUndefined(subsectionSummary)
            ? null : this.renderContracts(data, subsectionSummary, loadingMoreData, isLimited, isMirriReport);
    }

    renderContracts = (data, subsectionSummary, isLoading, isLimited, isMirriReport = false) => {
        const max = data.length > this.pageSize * this.state.page ? this.pageSize * this.state.page : data.length;
        const totalCount = subsectionSummary.items.reduce((a, b) => a + b.count, 0);

        if (!isLimited && isLoading)
            return <Circles />;

        return (
            <>
                <div className="hide-on-desktop" style={{ marginBottom: "0.5em" }}>
                    {this.renderContractTableMobileHeadTable(subsectionSummary)}
                </div>
                <ResponsiveTable>
                    <OldStyleTableWithHistory
                        tableColumns={6} stripped
                        head={() => this.renderContractTableHead(subsectionSummary, this.props.subsectionData.contractId, isMirriReport)}
                        actualData={this.getDataToRender(data.slice(0, max))}
                        actualRow={(r) => this.renderRow(r, this.props.subsectionData.contractId, isMirriReport)}
                    />
                </ResponsiveTable>
                {isLimited && totalCount > max && this.renderMoreLinks(totalCount, isLoading)}
                {!isLimited && totalCount > this.pageSize && <div style={{ marginTop: "2em" }}>
                    <Paging
                        justify="center"
                        selectedPage={this.state.page}
                        totalPages={Math.ceil(totalCount / this.pageSize)}
                        setPage={page => this.onChangePage(page)}
                    />
                </div>}
            </>
        )
    }

    renderContractTableHead = (subsectionSummary, typeId, isMirriReport = false) => {
        return (
            <thead className="pub-contracts-header">
                <tr>
                    <th />
                    <th className="col-2" />
                    <th className="col-3" style={{ textAlign: "right" }}><Translate id="Report.PublicContracts.ContractedAmount" /></th>
                    <th className="col-4" style={{ textAlign: "right" }}><Translate id="Report.PublicContracts.TotalAmount" /></th>
                    <th className="col-5" />
                    <th className="col-6" />
                </tr>
                {subsectionSummary.items.map(item => <tr key={item.currency} className="head">
                    <th>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <div><Translate id="Report.PublicContracts.ContractsCount" /></div>
                            <div>{item.countFormated}</div>
                        </div>
                    </th>
                    <th className="col-2"><Translate id="Report.PublicContracts.SuperTotalValue" data={{ currency: item.currency }} /></th>
                    <th className="col-3" style={{ textAlign: "right" }}>{item.contractedAmount}</th>
                    <th className="col-4" style={{ textAlign: "right" }}>{item.totalAmount}</th>
                    <th className="col-5" />
                    <th className="col-6" />
                </tr>)}
                <tr>
                    <th>
                        {typeId === '01' && <Translate id='Report.PublicContracts.Purchaser' />}
                        {typeId === '02' && <Translate id='Report.PublicContracts.Supplier' />}
                    </th>
                    <th className="col-2"><Translate id="Report.PublicContracts.ContractName" /></th>
                    <th className="col-3" style={{ textAlign: "right" }} />
                    <th className="col-4" style={{ textAlign: "right" }} />
                    <th className="col-5"><Translate id="Report.PublicContracts.Note" /></th>
                    {!isMirriReport && <th className="col-6" style={{ overflowWrap: "break-word", wordWrap: "break-word" }}><Translate id="Report.PublicContracts.Announcement" />/&#8203;<Translate id="Report.PublicContracts.Validity" /></th>}
                    { isMirriReport && <th className="col-6" style={{ overflowWrap: "break-word", wordWrap: "break-word" }}><Translate id="Report.PublicContracts.ContractDate" /></th>}
                </tr>
            </thead>
        );
    }

    renderContractTableMobileHeadTable = (subsectionSummary) => {
        return (
            <OldStyleTableWithHistory stripped noMargin tableColumns={5}
                resolveExpanded={this.props.resolveExpanded}
                head={() => <thead>
                    <tr>
                        <th></th>
                        <th style={{ width: "27%" }}></th>
                        <th style={{ textAlign: "right" }}><Translate id="Report.PublicContracts.ContractedAmount" /></th>
                        <th style={{ textAlign: "right" }}><Translate id="Report.PublicContracts.TotalAmount" /></th>
                    </tr>
                </thead>}
                actualData={subsectionSummary.items.map((s, i) => ({ ...s, index: i }))}
                actualRow={(item) => <tr key={item.currency} className="colorize">
                    <td style={{ fontWeight: "bold" }}>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <div><Translate id="Report.PublicContracts.ContractsCount" /></div>
                            <div>{item.countFormated}</div>
                        </div>
                    </td>
                    <td style={{ fontWeight: "bold" }}><Translate id="Report.PublicContracts.SuperTotalValue" data={{ currency: item.currency }} /></td>
                    <td style={{ textAlign: "right" }}>{item.contractedAmount}</td>
                    <td style={{ textAlign: "right" }}>{item.totalAmount}</td>
                </tr>}
            />
        );
    }

    renderRow = (r, typeId, isMirriReport = false) => {
        return (
            <tr key={r.contract.id + '_' + r.subject.id} className='pub-contracts-row colorize'>
                <td data-label={typeId === '01' ? this.props.translate("Report.PublicContracts.Purchaser") : (typeId === '02' ? this.props.translate("Report.PublicContracts.Supplier") : '')}>
                    <RelationLink entityName={r.subject.name} entityId={r.subject.id}
                        reports={{ GR: r.subject.hasGr, RP: r.subject.hasPr, RD: r.subject.hasRd, primaryAttr: r.subject.primaryAttr }} showOnMobile={true} />
                </td>
                <td data-label={this.props.translate("Report.PublicContracts.ContractName")}>
                    {this.renderContractLink(r.contract.contractTitle, r.contract.otherSourceNumber, r.contract.marketAttr)}
                </td>
                <td className="col-3" data-label={this.props.translate("Report.PublicContracts.ContractedAmount")}>{r.contract.contractedAmount}</td>
                <td className="col-4" data-label={this.props.translate("Report.PublicContracts.TotalAmount")}>{r.contract.totalAmount}</td>
                <td data-label={this.props.translate("Report.PublicContracts.Note")}>{r.contract.note}</td>
                {!isMirriReport && <td data-label={`${this.props.translate("Report.PublicContracts.Announcement")}/${this.props.translate("Report.PublicContracts.Validity")}`} style={{ overflowWrap: "break-word", wordWrap: "break-word" }}>
                    {r.contract.start === null || r.contract.start === undefined ? '-' : r.contract.startFormated}/
                    {r.contract.end === null || r.contract.end === undefined ? '-' : r.contract.endFormated}
                </td>}
                {isMirriReport && <td data-label={`${this.props.translate("Report.PublicContracts.ContractDate")}`} style={{ overflowWrap: "break-word", wordWrap: "break-word" }}>
                    {r.contract.contractDate === null || r.contract.contractDate === undefined ? '-' : r.contract.contractDateFormatted}
                </td>}
            </tr>
        )
    }

    renderContractLink(name, number, marketAttr) {
        if (number) {
            var href = '';
            if (marketAttr === 1)
                href = 'https://smlouvy.gov.cz/smlouva/' + number;
            else if (marketAttr === 2)
                href = 'https://www.crz.gov.sk/index.php?ID=' + number;
            return <a className="link-external" href={href} target='_blank'>{name}</a>
        }
        else
            return <span>{name}</span>
    }

    renderMoreLinks = (totalCount, isLoading) => {
        return (
            <>
                <div>
                    {this.state.page === 1 && <span className="link-functional" onClick={() => this.getMore()}>
                        <Translate id="Report.Common.More" />
                    </span>}
                    {this.state.page === 2 && <a className="link-functional" target="_blank"
                        href={this.props.getUnlimitedSectionLink(this.props.reportType, this.props.id, this.props.sectionId)}
                    >
                        <Translate id="Report.Common.ShowAll" />&nbsp;({totalCount})
                    </a>}
                </div>
                {isLoading && <div style={{ width: "100%" }} className="search-progress searching"></div>}
            </>
        )
    }

    getDataToRender = (contracts) => {
        const arr = contracts.map(contract => contract.subjects.map((subject) => ({ contract, subject })));
        return [].concat(...arr); // IE friendly array flattening
    }

    getMore = () => {
        this.props.fetchMoreData(
            [this.props.sectionId, this.props.subsectionId],
            { count: this.pageSize, offset: this.pageSize, report: this.props.reportType, type: this.props.subsectionData.contractId },
            null, this.concatData, () => this.setState({ page: 2 })
        );
    }

    onChangePage = (page) => {
        this.props.fetchMoreData(
            [this.props.sectionId, this.props.subsectionId],
            { count: this.pageSize, offset: (page - 1) * this.pageSize, report: this.props.reportType, type: this.props.subsectionData.contractId },
            null, this.replaceData, () => this.setState({ page: page })
        );
    }

    concatData = (_, oldData, newData) => oldData.concat(newData);
    replaceData = (_hint, _oldData, data) => data;
}

export default withLocalize(connect(
    state => state.report,
    dispatch => bindActionCreators(reportActions, dispatch)
)(PublicContractsSection));